module.exports = __webpack_public_path__ + "img/127.856c909c.jpg";